import React, { useState } from "react";
import { Badge, Button, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import { dateTimeFormatter } from "../../../../global";
import IconButton from "../../../../components/IconButton";
import {
  faKey,
  faPencil as PencilIcon,
  faTrash as DeleteIcon,
} from "@fortawesome/free-solid-svg-icons";
import FabPlateau from "../../../../components/UiComponents/Buttons/FabPlateau";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { showSuccessToast } from "../../../../components/Toasts";
import EditAccessKeyModal from "../EditAccessKeyModal";
import ConfirmDeleteDialog from "../../../../components/Modal/ConfirmDelete";
import useAccessKeys from "../hooks/useAccessKeys";
import useModal from "../../../../components/Modal/hooks/useModal";
import Table from "../../../../components/Tables/Table";

const columns = [
  { value: "id", name: "ID" },
  { value: "name", name: "Name" },
  { value: "valid_until", name: "Gültig bis" },
  { value: "nfc_card_uid", name: "NFC Nummer" },
  { value: "options", name: "Optionen" },
];

const AccessKeySection = () => {
  const { archive, accessKeys, loaded, fetchAccessKeys } = useAccessKeys();
  const { isShow: showArchive, toggle: toggleArchive } = useModal();
  const { isShow: showEdit, toggle: toggleEdit } = useModal();
  const [selectedAccessKey, setSelectedAccessKey] = useState({});

  const handleEdited = () => {
    showSuccessToast();
    fetchAccessKeys();
  };

  const handleDelete = () => {
    archive(selectedAccessKey);
    toggleArchive();
  };

  function handleEdit(accessKey) {
    setSelectedAccessKey(accessKey);
    toggleEdit();
  }

  function handleArchive(accessKey) {
    setSelectedAccessKey(accessKey);
    toggleArchive();
  }

  function handleCreate() {
    toggleEdit();
    setSelectedAccessKey({});
  }

  return (
    <Card title={`Alle Zutrittsschlüssel (${accessKeys.length ?? 0})`}>
      <div className="table-responsive">
        <div className="ui-table-container">
          <Table
            columns={columns}
            empty={loaded && accessKeys.length === 0}
            emptyMessage="Keine Zutrittsschlüssel vorhanden"
            className="table table-bordered"
            id="dataTable"
            width="100%"
            cellSpacing="0"
          >
            {accessKeys &&
              accessKeys.map((access_key) => {
                return (
                  <tr key={access_key.id}>
                    <td>
                      {access_key.id}
                      &nbsp;
                      {access_key.active ? (
                        <Badge pill variant="success" text="light">
                          Aktiv
                        </Badge>
                      ) : (
                        <Badge pill variant="danger" text="light">
                          Nicht aktiv
                        </Badge>
                      )}
                    </td>
                    <td>{access_key.name}</td>
                    <td>
                      {access_key.valid_until &&
                        dateTimeFormatter(access_key.valid_until)}
                    </td>
                    <td>{access_key.nfc_card_uid}</td>
                    <td>
                      <IconButton
                        className="mr-1 bg-transparent border-0 mr-3"
                        textColor="var(--primary)"
                        icon={PencilIcon}
                        onClick={() => handleEdit(access_key)}
                      />
                      <IconButton
                        className="mr-2 mr-3 bg-transparent border-0"
                        textColor="var(--danger)"
                        icon={DeleteIcon}
                        onClick={() => handleArchive(access_key)}
                      />
                    </td>
                  </tr>
                );
              })}
          </Table>
        </div>
      </div>
      <Row className="justify-content-end mr-2 mt-5">
        <FabPlateau>
          <Button
            className="float-right p-2 pl-3 pr-3"
            variant="primary"
            onClick={handleCreate}
          >
            <FontAwesomeIcon icon={faKey} /> &nbsp;Zutrittsschlüssel erstellen
          </Button>
        </FabPlateau>
      </Row>
      <EditAccessKeyModal
        show={showEdit}
        toggle={toggleEdit}
        access_key={selectedAccessKey}
        handleSuccess={handleEdited}
      />
      <ConfirmDeleteDialog
        show={showArchive}
        handleClose={toggleArchive}
        handleDelete={handleDelete}
      />
    </Card>
  );
};

export default AccessKeySection;
